import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-operation-wise-month',
  templateUrl: './operation-wise-month.component.html',
  styleUrls: ['./operation-wise-month.component.scss']
})
export class OperationWiseMonthComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
